import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landing.scss";
import WaterMarkFeature from "../../Components/LandingComponents/WaterMarkFeature";
import Banner from "../../Components/FeaturesComponent/banner";
import MoreWaterMarkFeature from "../../Components/FeaturesComponent/moreFeatures";

const Features = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Banner />
      <WaterMarkFeature />
      <MoreWaterMarkFeature />
    </>
  );
};

export default Features;
